export var EXPAY_PROVIDER = 21;
export var USDT_PROVIDER = 20;



// WEBPACK FOOTER //
// ./src/constants/Withdraw.js